"use strict";

require("core-js/modules/es.array.iterator.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
require("core-js/modules/es.object.get-own-property-descriptor.js");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.map.js");
require("core-js/modules/es.number.constructor.js");
require("core-js/modules/es.object.keys.js");
require("core-js/modules/es.string.small.js");
require("core-js/modules/es.function.name.js");
require("core-js/modules/es.array.concat.js");
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _classnames2 = _interopRequireDefault(require("classnames"));
var _usePrefixCls = require("../_utils/hooks/usePrefixCls");
var _teaComponent = require("@tencent/tea-component");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
// 在这里引入 tea-portal 组件，样式在 style/index.ts 中引入
// import Avatar from '@tencent/tea-portal/lib/Avatar';

// 在这里引入其他组件，样式在 style/index.ts 中引入
// import Button from '../Button';
var PublishModal = function PublishModal(props) {
  var className = props.className,
    style = props.style,
    visible = props.visible,
    sideImg = props.sideImg,
    img = props.img,
    price = props.price,
    status = props.status,
    title = props.title,
    sponsor = props.sponsor,
    time = props.time,
    viewClick = props.viewClick,
    venue = props.venue,
    tickets = props.tickets,
    participants = props.participants,
    btns = props.btns,
    alertInfos = props.alertInfos,
    viewActive = props.viewActive,
    onClose = props.onClose;
  var prefixCls = (0, _usePrefixCls.usePrefixCls)('publish-modal');
  var classes = (0, _classnames2.default)(prefixCls, className, (0, _defineProperty2.default)({}, 'is-close', onClose));
  var _useState = (0, _react.useState)(0),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    totalparticipants = _useState2[0],
    setTotalparticipants = _useState2[1];
  var _useState3 = (0, _react.useState)(0),
    _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
    totaltickets = _useState4[0],
    setTotaltickets = _useState4[1];
  (0, _react.useEffect)(function () {
    var total = 0;
    participants === null || participants === void 0 ? void 0 : participants.map(function (participant, index) {
      total += Number(participant !== null && participant !== void 0 && participant.sum ? participant.sum : 0);
    });
    setTotalparticipants(total);
  }, [participants]);
  (0, _react.useEffect)(function () {
    var total = 0;
    tickets === null || tickets === void 0 ? void 0 : tickets.map(function (item, index) {
      var _item$tickets;
      total += Number(item !== null && item !== void 0 && (_item$tickets = item.tickets) !== null && _item$tickets !== void 0 && _item$tickets.length ? item.tickets.length : 0);
    });
    setTotaltickets(total);
  }, [tickets]);
  var handlerClose = function handlerClose() {
    if (typeof onClose === 'function') {
      onClose();
    }
  };
  return /*#__PURE__*/_react.default.createElement(_teaComponent.Modal, {
    visible: visible,
    caption: "\u53D1\u5E03\u786E\u8BA4",
    onClose: handlerClose,
    className: classes,
    style: style
  }, /*#__PURE__*/_react.default.createElement(_teaComponent.Modal.Body, null, alertInfos, /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(prefixCls, "__panel")
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(prefixCls, "__object"),
    style: {
      backgroundImage: "url(".concat(img, ")")
    }
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "".concat(prefixCls, "__price")
  }, price), /*#__PURE__*/_react.default.createElement("span", {
    className: (0, _classnames2.default)("".concat(prefixCls, "__status"), status === null || status === void 0 ? void 0 : status.type)
  }, status === null || status === void 0 ? void 0 : status.text)), /*#__PURE__*/_react.default.createElement("main", {
    className: "".concat(prefixCls, "__main")
  }, /*#__PURE__*/_react.default.createElement(_teaComponent.Tooltip, {
    title: title
  }, /*#__PURE__*/_react.default.createElement("h3", {
    className: "".concat(prefixCls, "__title")
  }, title)), /*#__PURE__*/_react.default.createElement("ul", {
    className: "".concat(prefixCls, "__infos")
  }, /*#__PURE__*/_react.default.createElement("li", {
    className: "".concat(prefixCls, "__info sponsor")
  }, sponsor), /*#__PURE__*/_react.default.createElement("li", {
    className: "".concat(prefixCls, "__info time")
  }, time)), /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(prefixCls, "__opts")
  }, viewClick && /*#__PURE__*/_react.default.createElement("a", {
    className: "".concat(prefixCls, "__opt view"),
    onClick: viewClick
  }, "\u9884\u89C8\u6D3B\u52A8\u8BE6\u60C5\u9875"), viewActive && /*#__PURE__*/_react.default.createElement("a", {
    className: "".concat(prefixCls, "__opt none-icon"),
    onClick: viewActive
  }, "\u9884\u89C8\u6D3B\u52A8\u5927\u5385")))), venue && Object.keys(venue).length > 0 && /*#__PURE__*/_react.default.createElement("dl", {
    className: "".concat(prefixCls, "__group")
  }, /*#__PURE__*/_react.default.createElement("dt", null, "\u65E5\u7A0B\u4FE1\u606F"), /*#__PURE__*/_react.default.createElement("dd", null, /*#__PURE__*/_react.default.createElement("h4", {
    className: "".concat(prefixCls, "__group-sum")
  }, "\u5171", ' ', venue ? Number(venue !== null && venue !== void 0 && venue.large ? venue.large : 0) + Number(venue !== null && venue !== void 0 && venue.small ? venue.small : 0) + Number(venue !== null && venue !== void 0 && venue.brand ? venue.brand : 0) : 0, ' ', "\u4E2A\u65E5\u7A0B"), /*#__PURE__*/_react.default.createElement("ul", {
    className: "".concat(prefixCls, "__details")
  }, Object.keys(venue).indexOf('large') > -1 && !!Number(venue !== null && venue !== void 0 && venue.large ? venue.large : 0) && /*#__PURE__*/_react.default.createElement("li", {
    className: "".concat(prefixCls, "__detail")
  }, !!venue.largeIcon ? venue.largeIcon : /*#__PURE__*/_react.default.createElement("i", {
    className: "".concat(prefixCls, "__detail-icon large-venue")
  }), !!venue.largeText ? venue.largeText : '大型会场', /*#__PURE__*/_react.default.createElement("em", null, venue === null || venue === void 0 ? void 0 : venue.large), "\u4E2A"), Object.keys(venue).indexOf('small') > -1 && !!Number(venue !== null && venue !== void 0 && venue.small ? venue.small : 0) && /*#__PURE__*/_react.default.createElement("li", {
    className: "".concat(prefixCls, "__detail")
  }, !!venue.smallIcon ? venue.smallIcon : /*#__PURE__*/_react.default.createElement("i", {
    className: "".concat(prefixCls, "__detail-icon small-venue")
  }), !!venue.smallText ? venue.smallText : '小型讨论室', /*#__PURE__*/_react.default.createElement("em", null, venue === null || venue === void 0 ? void 0 : venue.small), "\u4E2A"), Object.keys(venue).indexOf('brand') > -1 && !!Number(venue !== null && venue !== void 0 && venue.brand ? venue.brand : 0) && /*#__PURE__*/_react.default.createElement("li", {
    className: "".concat(prefixCls, "__detail")
  }, !!venue.brandIcon ? venue.brandIcon : /*#__PURE__*/_react.default.createElement("i", {
    className: "".concat(prefixCls, "__detail-icon brand-booth")
  }), !!venue.brandText ? venue.brandText : '品牌展位', /*#__PURE__*/_react.default.createElement("em", null, venue === null || venue === void 0 ? void 0 : venue.brand), "\u4E2A")))), tickets && tickets.length > 0 && /*#__PURE__*/_react.default.createElement("dl", {
    className: "".concat(prefixCls, "__group")
  }, /*#__PURE__*/_react.default.createElement("dt", null, "\u95E8\u7968\u4FE1\u606F"), /*#__PURE__*/_react.default.createElement("dd", {
    className: "column"
  }, /*#__PURE__*/_react.default.createElement("h4", {
    className: "".concat(prefixCls, "__group-sum")
  }, "\u5171 ", totaltickets, " \u4E2A\u7968\u79CD"), tickets === null || tickets === void 0 ? void 0 : tickets.map(function (item, index) {
    var _item$tickets2;
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "".concat(prefixCls, "__param"),
      key: index
    }, (item === null || item === void 0 ? void 0 : item.label) && /*#__PURE__*/_react.default.createElement("div", {
      className: "".concat(prefixCls, "__param-label")
    }, item === null || item === void 0 ? void 0 : item.label), /*#__PURE__*/_react.default.createElement("ul", {
      className: "".concat(prefixCls, "__details")
    }, item === null || item === void 0 ? void 0 : (_item$tickets2 = item.tickets) === null || _item$tickets2 === void 0 ? void 0 : _item$tickets2.map(function (ticket, index) {
      return ticket.sum !== 0 && /*#__PURE__*/_react.default.createElement("li", {
        className: "".concat(prefixCls, "__detail"),
        key: index
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "text"
      }, "".concat(ticket.name)), "".concat(ticket.price ? " ".concat(ticket.price) : '', " \u5171 ").concat(ticket.sum, " \u5F20"));
    })));
  })), /*#__PURE__*/_react.default.createElement("dd", null)), participants && participants.length > 0 && /*#__PURE__*/_react.default.createElement("dl", {
    className: "".concat(prefixCls, "__group")
  }, /*#__PURE__*/_react.default.createElement("dt", null, "\u4EBA\u5458\u4FE1\u606F"), /*#__PURE__*/_react.default.createElement("dd", null, /*#__PURE__*/_react.default.createElement("h4", {
    className: "".concat(prefixCls, "__group-sum")
  }, "\u5171 ", totalparticipants, " \u4EBA"), /*#__PURE__*/_react.default.createElement("ul", {
    className: "".concat(prefixCls, "__details")
  }, participants === null || participants === void 0 ? void 0 : participants.map(function (participant, index) {
    return !!Number(participant !== null && participant !== void 0 && participant.sum ? participant === null || participant === void 0 ? void 0 : participant.sum : 0) && /*#__PURE__*/_react.default.createElement("li", {
      className: "".concat(prefixCls, "__detail"),
      key: index
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: "text"
    }, "".concat(participant.type)), "".concat(participant.sum, " \u4EBA"));
  }))))), /*#__PURE__*/_react.default.createElement(_teaComponent.Modal.Footer, null, btns === null || btns === void 0 ? void 0 : btns.map(function (btn, index) {
    return /*#__PURE__*/_react.default.createElement(_teaComponent.Button, (0, _extends2.default)({}, btn, {
      key: "index"
    }), btn.text);
  })));
};
var _default = PublishModal;
exports.default = _default;